import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import ReactPaginate from 'react-paginate';
import Content from '../Content/Content';
import './Pagination.css';
import Carousel from '../Carousel/Carousel';
import {  toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

// Example items, to simulate fetching from another resources.


function Pagination({ itemsPerPage, color }) {
    let navigate = useNavigate();
    const token = localStorage.getItem("token");
    const [items, setitems] = useState([]);
    const [search, setsearch] = useState('');
    useEffect(() => {
        fetch('https://api.coingecko.com/api/v3/coins/markets?vs_currency=inr&order=market_cap_desc&per_page=70&page=1&sparkline=false')
            .then(res => res.json())
            .then(data => {
                console.log(data);
                setitems(data);
            });
        // if(token==null){
        //     toast('Login to proceed further', {
        //         position: "top-center",
        //         autoClose: 2000,
        //         type: "error",
        //         theme: "colored",
        //         hideProgressBar: false,
        //         closeOnClick: true,
        //         pauseOnHover: true,
        //         draggable: true,
        //         progress: undefined,
        //         })
        //     navigate('/login');
        // }
    }, [search]);
    // We start with an empty list of items.
    const [currentItems, setCurrentItems] = useState(null);
    const [pageCount, setPageCount] = useState(0);
    // Here we use item offsets; we could also use page offsets
    // following the API or data you're working with.
    const [itemOffset, setItemOffset] = useState(0);

    useEffect(() => {
        // Fetch items from another resources.
        const endOffset = itemOffset + itemsPerPage;
        // console.log(`Loading items from ${itemOffset} to ${endOffset}`);
        setCurrentItems(items.slice(itemOffset, endOffset));
        setPageCount(Math.ceil(items.length / itemsPerPage));
    }, [itemOffset, itemsPerPage, items]);

    // Invoke when user click to request another page.
    const handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % items.length;
        // console.log(
        //     `User requested page number ${event.selected}, which is offset ${newOffset}`
        // );
        setItemOffset(newOffset);
    };
    // console.log(search);
    function handleSearch(){
        let arr = [];
        if(search.length == 0){
            return;
        }else{
            arr = items.filter(item=> (item.name.toLowerCase().includes(search))) || items.filter(item=> (item.symbol.toLowerCase().includes(search)));

        }
        if(arr.length!=0){
            setitems(arr);
        }
    }
    // function onSearch(e){
    //     setsearch(e.target.value);
    //     handleSearch();
    // }

    return (
        <div style={{marginTop:"60px"}}>
            <Carousel/>
            <div className='search-box my-3'>
                <input type="text" className='searchText' placeholder='Type to search..' value={search} onChange={e=> setsearch(e.target.value)}/>
                <button onClick={handleSearch} className='searchBtn'><i className="fa-solid fa-magnifying-glass fa-2x"></i></button>
            </div>
            <Content currentItems={currentItems} color={color} />
            <ReactPaginate
                previousLabel={"<<"}
                nextLabel={">>"}
                breakLabel={"..."}
                pageCount={pageCount}
                marginPagesDisplayed={4}
                pageRangeDisplayed={4}
                onPageChange={handlePageClick}
                containerClassName={"pagination justify-content-center"}
                pageClassName={"page-item"}
                pageLinkClassName={"page-link"}
                previousClassName={"page-item"}
                previousLinkClassName={"page-link"}
                nextClassName={"page-item"}
                nextLinkClassName={"page-link"}
                breakClassName={"page-item"}
                breakLinkClassName={"page-link"}
                activeClassName={"active"}
            />
        </div>
    );
}

export default Pagination;